const user = {
    _details: JSON.parse(localStorage.getItem('user')) || null,
    _token: localStorage.getItem('token') || '',
    _passwordVerify: !!sessionStorage.getItem('password-verify'),
    _cart: JSON.parse(localStorage.getItem('cart')) || [],
    _wishlist: JSON.parse(localStorage.getItem('wishlist')) || [],
    _orders:  JSON.parse(localStorage.getItem('orders')) || [],
}

module.exports = { user }